var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"center",attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-progress-circular',{attrs:{"size":100,"color":"primary","indeterminate":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }